import type { Patient } from '@dnx/contracts';
import { Button } from '@dnx/ui';
import { useMutation, useQuery, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { ClipboardList } from 'lucide-react';
import { api } from '../lib/api.js';
import { meQuery } from '../lib/session.js';
import { patientByContactQuery } from './queries.js';

/** Atalho do lead/conversa para o prontuário (abre o existente ou cria na hora). Só aparece para a equipe clínica. */
export function PatientLinkButton({ contactId }: { contactId: string }) {
  const { data: me } = useSuspenseQuery(meQuery);
  const canRead = me.permissions.includes('clinical.record.read');
  const canWrite = me.permissions.includes('clinical.record.write');
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data } = useQuery({ ...patientByContactQuery(contactId), enabled: canRead });
  const open = (id: string) => void navigate({ to: '/pacientes/$id', params: { id } });
  const create = useMutation({
    mutationFn: () => api<Patient>('/patients', { method: 'POST', body: { contactId } }),
    onSuccess: (p) => { void qc.invalidateQueries({ queryKey: ['patients'] }); open(p.id); },
  });
  if (!canRead || !data) return null;
  if (data.patientId) return <Button size="sm" variant="secondary" onClick={() => open(data.patientId!)}><ClipboardList className="size-4" />Prontuário</Button>;
  if (!canWrite) return null;
  return <Button size="sm" variant="secondary" loading={create.isPending} onClick={() => create.mutate()}><ClipboardList className="size-4" />Abrir prontuário</Button>;
}
